import { useEffect, useState } from 'react';

import { useI18n, useSettings } from '../hooks';

import SiteIsClosed from './SiteIsClosed';
import FlipNumber from './FlipNumber';
import { useMediaQuery } from '@material-ui/core';

let timer: NodeJS.Timeout | null = null

const Countdown: React.FC = () => {

	const [currentCountdown, setCurrentCountdown] = useState<{ name: string, value: number, max1: number, max2: number, max3?: number }[]>([])
	const settingsCtx = useSettings();
	const countdownText = useI18n(i18n => i18n.countdownText);
	const errText = useI18n(i18n => i18n.errText);
	const isBgImgShown = useMediaQuery('(min-width: 1300px)');
	const isSmallImgShown = useMediaQuery('(max-width: 500px)');

	useEffect(() => {
		if (settingsCtx.settings) {
			updateTimeBetweenDates()
			timer = setInterval(function () {
				updateTimeBetweenDates();
			}, 60000);
		}

		return () => { clearInterval(timer as NodeJS.Timeout) }
	}, [settingsCtx.settings])

	const updateTimeBetweenDates = () => {

		let difference = new Date(settingsCtx.settings!.countdownDate).getTime() - new Date().getTime();

		if (difference <= 0) clearInterval(timer as NodeJS.Timeout)
		else {
			const minutesBeforeModulo = Math.floor(Math.floor(difference / 1000) / 60);
			const hoursBeforeModulo = Math.floor(minutesBeforeModulo / 60);
			const days = Math.floor(hoursBeforeModulo / 24);

			setCurrentCountdown([
				{ name: countdownText.minutes, value: minutesBeforeModulo % 60, max1: 5, max2: 9 },
				{ name: countdownText.hours, value: hoursBeforeModulo % 24, max1: 2, max2: 9 },
				{ name: countdownText.days, value: days, max1: 9, max2: 9, max3: 9 }
			])
		}
	}

	return (
		settingsCtx.error ? <div id="countdown-container">{errText.generalSystem}</div> :
			!settingsCtx.settings ? <></> :
				settingsCtx.settings?.siteIsOpen && settingsCtx.timeIsOut ? <></> : //{/* <SiteIsClosed /> */}
					!settingsCtx.settings?.siteIsOpen && settingsCtx.timeIsOut ? <></> :
						!settingsCtx.settings?.siteIsOpen && !settingsCtx.settings?.showCountdown ? <></> : //{/* <SiteIsClosed /> */}
							settingsCtx.settings?.siteIsOpen && !settingsCtx.settings?.showCountdown ? <></> :

								<div id="countdown-container" >
									{(isBgImgShown || isSmallImgShown) && <img id='countdown-background-img' src={`/lulav-icons/${isSmallImgShown ? 'mobile-' : ''}countdown-background.${isBgImgShown ? 'png' : 'svg'}`} />}
									<div id="countdown-text" >
										{settingsCtx.settings?.siteIsOpen ?
											`${countdownText.closesInAnother}:`
											: `${countdownText.opensInAnother}:`}
									</div>

									<div id="countdown">
										{currentCountdown.map((item, index) => {
											const value = (item.value < 10 ? '0' + item.value : item.value)
											return (
												<div key={index} className="flex" style={{ flexDirection: 'row' }}>
													<div className="countdown-item">

														<div className="countdown-item-value" dir="rtl">
															{value.toString().split('').map((digit, index) => (
																<FlipNumber
																	key={index}
																	max={item[`max${index + 1}` as keyof typeof item] as number}
																	value={parseInt(digit)}
																/>
															))}
														</div>
														<div className="countdown-item-name">{item.name}</div>
													</div>

													{index !== currentCountdown.length - 1 ?
														<div className="countdown-item-value countdown-item-colon" > : </div>
														: null}
												</div>
											)
										})}
									</div>
								</div>
	);
}

export default Countdown;